import { BehaviorSubject } from 'rxjs'
export default new BehaviorSubject(false)
